<div class="sin-registros text-center" style="margin-top: 40px;margin-bottom: 40px;">
  <div class="fs-15">
    @if (spin) {
      <span><span class="material-symbols-outlined mat-spin color-gray fs-30">progress_activity</span></span>
    } @else {
      <span>
        <p><span class="material-symbols-outlined fs-30 color-gray">block</span></p>
        <p>{{ text }}</p>
      </span>
    }
  </div>
</div>